import $ from "jquery";
import './jquery.colorbox.min.js';
import config from '../../lib/config';

var colorboxEl = config.colorboxEl;
		

if (colorboxEl.length > 0) {
	colorboxEl.each( function() {
		var figure = $(this).find('figure'),
				imgSrc = $(this).find( 'img' ).attr('src'),
				link = '<a href="'+imgSrc+'" class="cb-link"></a>';
		
		figure.wrap(link);
	});

}

if ( $('.cb-link').length > 0 ) {
  $('.cb-link').colorbox({
    maxHeight: '95%',
    maxWidth: '95%',
    scalePhotos: true,
    rel: 'gal',
    scrolling: false,
    closeButton: true
  });
}